import { makeStyles } from "@material-ui/core";

const useLoadsPricingStyles = makeStyles((theme) => ({
  pricingRubricPaper: {
    marginTop: 24,
    width: '100%',
    borderRadius: 12,
    boxShadow: '0 2px 12px rgba(0,0,0,0.07)'
  },
  pricingRubricSectionTitle: {
    fontWeight: 500,
    marginBottom: 8
  },
  pricingRubricAccordion: {
    borderRadius: 10,
    boxShadow: '0 1px 6px rgba(0,0,0,0.04)',
    marginBottom: 8
  },
  pricingRubricAccordionSummary: {
    borderRadius: 10,
    background: '#f4f6f8'
  },
  pricingRubricAssetClass: {
    fontWeight: 600,
    fontSize: '1.08em',
    color: '#2d3a4a',
    width: '100%',
    textAlign: 'center'
  },
  pricingRubricAccordionDetails: {
    background: '#fafbfc',
    borderRadius: 10,
    display: 'block'
  },
  pricingRubricTable: {
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: 0,
    borderRadius: 8,
    overflow: 'hidden'
  },
  pricingRubricTableHeadRow: {
    background: '#f4f6f8'
  },
  leftAlign: {
  textAlign: 'left',
  paddingLeft: 5,
  },
  pricingRubricTableHead: {
    textAlign: 'right',
    padding: '8px 6px',
    fontWeight: 500,
    color: '#6b778c'
  },
  pricingRubricTableRowEven: {
    background: '#fff',
    transition: 'background 0.2s'
  },
  pricingRubricTableRowOdd: {
    background: '#f7f8fa',
    transition: 'background 0.2s'
  },
  pricingRubricTableCell: {
    padding: '6px 6px'
  },
  pricingRubricInput: {
    width: 90,
    fontSize: 14
  },
  pricingRubricAddButtonWrapper: {
    marginTop: 8,
    textAlign: 'right'
  },
  pricingRubricAddButton: {
    fontWeight: 400,
    fontSize: 13,
    borderRadius: 6,
    borderColor: '#d1d5db'
  },
  pricingRubricDivider: {
    margin: '0 0 8px 0'
  },
  spacing: {
    justifyContent: 'space-between',
    alignItems: 'center'
  }
}));

export default useLoadsPricingStyles;
